import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogEscapeService } from '../dialog/dialog-escape.service';
import { ConfirmDialogComponent, ConfirmDialogResult } from './confirm-dialog/confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
    constructor(
        public dialog: MatDialog,
        private dialogEscapeService: DialogEscapeService
    ) {}
    selectedOption: unknown | null = null;
    confirm<T>(options: {
        title: string;
        text: string;
        rightText?: string;
        confirm?: string;
        cancel?: string;
        cancelClass?: string;
        close?: boolean;
        options?: unknown[];
        width?: string;
        radio?: boolean;
        multiSelect?: boolean;
        dialogOptions?: MatDialogConfig;
    }) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm-dialog',
            width: options.width ?? '400px',
            maxWidth: '99vw',
            maxHeight: '98vh',
            minWidth: '250px',
            disableClose: true,
            autoFocus: options.radio ? 'mat-radio-button input' : '[cdkFocusInitial]',
            data: options,
            ...options.dialogOptions,
        });

        this.dialogEscapeService.setCloseBlocked(dialogRef, true);

        return new Promise<T | T[] | null>((resolve, reject) => {
            const subs = new Subscription();

            subs.add(
                dialogRef.componentInstance.optionChosen.subscribe(option => {
                    if (options.radio) {
                        this.selectedOption = option;

                        if (option.confirm === false) {
                            return;
                        }
                    }

                    resolve(option as any as T);

                    dialogRef.close();

                    subs.unsubscribe();
                })
            );

            subs.add(
                dialogRef.afterClosed().subscribe((result: ConfirmDialogResult | T) => {
                    subs.unsubscribe();

                    if (options.multiSelect) {
                        if (result) {
                            return resolve(
                                options.multiSelect && Array.isArray(result) ? (result as T[]) : (result as T)
                            );
                        } else {
                            return reject(null);
                        }
                    }

                    if (result === ConfirmDialogResult.Primary) {
                        resolve(options.radio ? (this.selectedOption as T) : null);
                    } else if (result === ConfirmDialogResult.Secondary) {
                        reject(true);
                    } else if (result === ConfirmDialogResult.Cancelled) {
                        reject(false);
                    }
                })
            );
        });
    }
}
